import { FormControl, FormControlLabel, Grid, RadioGroup } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import CustomFormLabel from 'src/components/forms/theme-elements/CustomFormLabel';
import CustomRadio from 'src/components/forms/theme-elements/CustomRadio';
import CustomTextField from 'src/components/forms/theme-elements/CustomTextField';
import { TournamentFormValues } from '../../types';
import { FormikProps } from 'formik';

const AdditionalInfo = ({ formik }: { formik: FormikProps<TournamentFormValues> }) => {
  return (
    <>
      <Grid item xs={12}>
        <CustomFormLabel htmlFor="prizes">{t('TournamentsScreen.prizes')}</CustomFormLabel>
        <CustomTextField
          id="prizes"
          fullWidth
          {...formik.getFieldProps('prizes')}
          error={formik.touched.prizes && Boolean(formik.errors.prizes)}
          helperText={formik.touched.prizes && formik.errors.prizes}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomFormLabel htmlFor="daily_timings">
          {t('TournamentsScreen.dailyTimings')}
        </CustomFormLabel>
        <CustomTextField
          id="daily_timings"
          fullWidth
          {...formik.getFieldProps('daily_timings')}
          error={formik.touched.daily_timings && Boolean(formik.errors.daily_timings)}
          helperText={formik.touched.daily_timings && formik.errors.daily_timings}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomFormLabel htmlFor="additional_info">
          {t('TournamentsScreen.additionalInfo')}
        </CustomFormLabel>
        <CustomTextField
          id="additional_info"
          fullWidth
          {...formik.getFieldProps('additional_info')}
          error={formik.touched.additional_info && Boolean(formik.errors.additional_info)}
          helperText={formik.touched.additional_info && formik.errors.additional_info}
        />
      </Grid>
      <Grid item xs={6}>
        <CustomFormLabel htmlFor="is_live">{t('TournamentsScreen.isLive')}</CustomFormLabel>
        <FormControl>
          <RadioGroup
            row
            value={formik.values.is_live}
            onChange={(e) => formik.setFieldValue('is_live', Number(e.target.value))}
          >
            <FormControlLabel value={1} control={<CustomRadio />} label={t('Common.yes')} />
            <FormControlLabel value={0} control={<CustomRadio />} label={t('Common.no')} />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <CustomFormLabel htmlFor="is_global">{t('TournamentsScreen.isGlobal')}</CustomFormLabel>
        <FormControl>
          <RadioGroup
            row
            value={formik.values.is_global}
            onChange={(e) => formik.setFieldValue('is_global', Number(e.target.value))}
          >
            <FormControlLabel value={1} control={<CustomRadio />} label={t('Common.yes')} />
            <FormControlLabel value={0} control={<CustomRadio />} label={t('Common.no')} />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <CustomFormLabel htmlFor="is_private">{t('TournamentsScreen.isPrivate')}</CustomFormLabel>
        <FormControl>
          <RadioGroup
            row
            value={formik.values.is_private}
            onChange={(e) => formik.setFieldValue('is_private', Number(e.target.value))}
          >
            <FormControlLabel value={1} control={<CustomRadio />} label={t('Common.yes')} />
            <FormControlLabel value={0} control={<CustomRadio />} label={t('Common.no')} />
          </RadioGroup>
        </FormControl>
      </Grid>
      {/* waiting list */}
      <Grid item xs={6}>
        <CustomFormLabel htmlFor="is_waiting_list">
          {t('TournamentsScreen.withWaitingList')}
        </CustomFormLabel>
        <FormControl>
          <RadioGroup
            row
            value={formik.values.is_waiting_list}
            onChange={(e) => formik.setFieldValue('is_waiting_list', Number(e.target.value))}
          >
            <FormControlLabel value={1} control={<CustomRadio />} label={t('Common.yes')} />
            <FormControlLabel value={0} control={<CustomRadio />} label={t('Common.no')} />
          </RadioGroup>
        </FormControl>
      </Grid>
      {/* is_golden_point */}
      <Grid item xs={6}>
        <CustomFormLabel htmlFor="is_golden_point">
          {t('TournamentsScreen.withGoldenPoint')}
        </CustomFormLabel>
        <FormControl>
          <RadioGroup
            row
            value={formik.values.is_golden_point}
            onChange={(e) => formik.setFieldValue('is_golden_point', Number(e.target.value))}
          >
            <FormControlLabel value={1} control={<CustomRadio />} label={t('Common.yes')} />
            <FormControlLabel value={0} control={<CustomRadio />} label={t('Common.no')} />
          </RadioGroup>
        </FormControl>
      </Grid>
      {/* is_third_set_tie_breaker */}
      <Grid item xs={6}>
        <CustomFormLabel htmlFor="is_third_set_tie_breaker">
          {t('TournamentsScreen.withThirdSetTieBreaker')}
        </CustomFormLabel>
        <FormControl>
          <RadioGroup
            row
            value={formik.values.is_third_set_tie_breaker}
            onChange={(e) =>
              formik.setFieldValue('is_third_set_tie_breaker', Number(e.target.value))
            }
          >
            <FormControlLabel value={1} control={<CustomRadio />} label={t('Common.yes')} />
            <FormControlLabel value={0} control={<CustomRadio />} label={t('Common.no')} />
          </RadioGroup>
        </FormControl>
      </Grid>
      {/* show_teams */}
      <Grid item xs={6}>
        <CustomFormLabel htmlFor="show_teams">{t('TournamentsScreen.showTeams')}</CustomFormLabel>
        <FormControl>
          <RadioGroup
            row
            value={formik.values.show_teams}
            onChange={(e) => formik.setFieldValue('show_teams', Number(e.target.value))}
          >
            <FormControlLabel value={1} control={<CustomRadio />} label={t('Common.yes')} />
            <FormControlLabel value={0} control={<CustomRadio />} label={t('Common.no')} />
          </RadioGroup>
        </FormControl>
      </Grid>
      {/* schedule_notifications */}
      <Grid item xs={6}>
        <CustomFormLabel htmlFor="schedule_notifications">
          {t('TournamentsScreen.scheduleNotifications')}
        </CustomFormLabel>
        <FormControl>
          <RadioGroup
            row
            value={formik.values.schedule_notifications}
            onChange={(e) => formik.setFieldValue('schedule_notifications', Number(e.target.value))}
          >
            <FormControlLabel value={1} control={<CustomRadio />} label={t('Common.yes')} />
            <FormControlLabel value={0} control={<CustomRadio />} label={t('Common.no')} />
          </RadioGroup>
        </FormControl>
      </Grid>
    </>
  );
};

export default AdditionalInfo;
